module.exports = __webpack_public_path__ + "static/media/nsfw.2389b07e.svg";